/**
 * Empire ATC Chromium fix (2026-08-21)
 *
 * Chromium/Edge were reaching AddToCartFlyout without a variant id (no /cart/add.js
 * request, red "Unable to add..." banner). This script takes over product-form
 * submit in the capture phase and calls the theme flyout with an explicit id.
 */
(function () {
  function whenReady(callback) {
    if (window.jQuery && window.GearUpAddToCartFlyout) {
      callback(window.jQuery);
      return;
    }
    setTimeout(function () {
      whenReady(callback);
    }, 30);
  }

  function resolveVariantId(form) {
    var idInput = form.querySelector('[name="id"]:not([disabled])') || form.querySelector('[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);

    var variants = form.querySelector('[data-variants]');
    if (variants && variants.value) return String(variants.value);

    if (window.__GU_ATC_VARIANT_ID) return String(window.__GU_ATC_VARIANT_ID);

    if (window.meta && window.meta.product && window.meta.product.variants && window.meta.product.variants[0]) {
      var first = window.meta.product.variants[0];
      if (first.id) return String(first.id);
    }

    return '';
  }

  function resolveQuantity(form) {
    var qtyInput = form.querySelector('[name="quantity"]');
    if (qtyInput && qtyInput.value) return String(qtyInput.value);
    return '1';
  }

  function collectProperties(form) {
    var fields = [];
    var elements = form.querySelectorAll('[name^="properties["]');
    for (var i = 0; i < elements.length; i++) {
      var el = elements[i];
      if (!el.name || el.disabled) continue;
      fields.push({ name: el.name, value: el.value });
    }
    return fields;
  }

  function isProductCartForm(form) {
    if (!form || form.tagName !== 'FORM') return false;
    if (form.hasAttribute('data-product-form')) return true;
    var action = form.getAttribute('action') || '';
    return action.indexOf('/cart/add') !== -1;
  }

  whenReady(function ($) {
    document.addEventListener(
      'submit',
      function (event) {
        var form = event.target;
        if (!isProductCartForm(form)) return;

        var variantId = resolveVariantId(form);
        if (!variantId) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        var quantity = resolveQuantity(form);
        var formData = [
          { name: 'id', value: variantId },
          { name: 'quantity', value: quantity }
        ].concat(collectProperties(form));

        var $form = $(form);
        var $atcButton = $form.find('[data-product-atc]');
        if (!$atcButton.length) {
          $atcButton = $(event.submitter || form.querySelector('[type="submit"]'));
        }

        window.GearUpAddToCartFlyout.init(formData, {
          $atcButton: $atcButton,
          settings: {
            moneyFormat: window.__GU_ATC_MONEY_FORMAT,
            cartRedirection: !!window.__GU_ATC_CART_REDIRECT
          }
        });
      },
      true
    );

    $.ajaxPrefilter(function (options) {
      if (!options || !options.url || String(options.url).indexOf('/cart/add') === -1) {
        return;
      }

      function toLineItem(data) {
        if (!data) return null;
        if (typeof data === 'string') {
          try {
            var parsed = JSON.parse(data);
            if (parsed && parsed.items && parsed.items[0] && parsed.items[0].id) {
              return {
                id: String(parsed.items[0].id),
                quantity: parseInt(parsed.items[0].quantity, 10) || 1,
                properties: parsed.items[0].properties || null
              };
            }
            if (parsed && parsed.id) {
              return {
                id: String(parsed.id),
                quantity: parseInt(parsed.quantity, 10) || 1,
                properties: parsed.properties || null
              };
            }
          } catch (e) {
            var params = new URLSearchParams(data);
            var id = params.get('id');
            if (id) {
              return {
                id: String(id),
                quantity: parseInt(params.get('quantity') || '1', 10) || 1,
                properties: null
              };
            }
          }
          return null;
        }

        if (typeof data === 'object') {
          if (data.items && data.items[0] && data.items[0].id) {
            return {
              id: String(data.items[0].id),
              quantity: parseInt(data.items[0].quantity, 10) || 1,
              properties: data.items[0].properties || null
            };
          }
          if (data.id) {
            return {
              id: String(data.id),
              quantity: parseInt(data.quantity, 10) || 1,
              properties: data.properties || null
            };
          }
        }
        return null;
      }

      var lineItem = toLineItem(options.data);
      if (!lineItem || !lineItem.id) return;

      var payload = {
        id: lineItem.id,
        quantity: lineItem.quantity || 1
      };
      if (lineItem.properties) {
        payload.properties = lineItem.properties;
      }

      options.data = $.param(payload);
      options.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
      options.processData = false;
      if (options.dataType == null) options.dataType = 'json';
    });
  });
})();
